import React, { useState, useEffect, useRef } from "react";
import { Box, Grid, InputAdornment, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const MIN_CHARS = 3;
const DEBOUNCE_MS = 500;

const SearchForm = ({ onSearch, initialValue = "" }) => {
  const [inputSearch, setInputSearch] = useState(initialValue);
  const debounceRef = useRef(null);

  useEffect(() => {
    setInputSearch(initialValue);
  }, [initialValue]);

  const handleChange = (e) => {
    const val = e.target.value;
    setInputSearch(val);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!val.trim()) {
      onSearch("");
      return;
    }

    if (val.trim().length >= MIN_CHARS) {
      debounceRef.current = setTimeout(() => {
        onSearch(val.trim());
      }, DEBOUNCE_MS);
    }
  };

  const handleResetSearch = () => {
    setInputSearch("");
    onSearch("");
  };

  return (
    <div>
      <Grid
        item
        container
        xs={12}
        style={{ display: "flex", alignItems: "center" }}
      >
        <Grid
          item
          xs={12}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder={`Cerca per nome e cognome o email cliente`}
            value={inputSearch}
            onChange={handleChange}
            InputProps={{
              endAdornment: inputSearch && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    onClick={handleResetSearch}
                    className="color-blue-dark"
                    edge="end"
                    sx={{ "&:hover": { backgroundColor: "transparent" } }}
                  >
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                "& fieldset": {
                  borderColor: "grey",
                  borderWidth: "1px",
                  borderRadius: "10px",
                },
                "&:hover fieldset": { borderColor: "#1b2838" },
                "&.Mui-focused fieldset": { borderColor: "#1b2838" },
              },
              "& input::placeholder": { fontSize: "14px" },
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SearchForm;
